import { ChevronDown } from "lucide-react";

export function TimeFilter() {
  return (
    <div className="inline-flex items-center rounded-[4.8px] border-[0.5px] border-[#e3e6e8] bg-[#FFFFFF80] px-1.5 py-1 leading-none">
      <span className="inline-flex items-center gap-0.5 p-0.5 text-[10px] leading-none text-[#1a2026]">
        All Time
        <ChevronDown className="size-2 shrink-0" strokeWidth={2} />
      </span>
    </div>
  );
}
